import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(3),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontSize: 12,
    marginBottom: theme.spacing(1),
    color: '#90A4AE',
  },
  button: {
    borderColor: theme.palette.colors.teal,
  },
  player: {
    marginRight: theme.spacing(2),
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/ProfileVideo/useStyles.js